<template>
  <div class="d-flex align-items-center" :class="{ 'opacity-50': disabled }">
    <input ref="checkbox" type="checkbox" :id="`checkbox-${id}`" class="d-none" :value="value" :disabled="disabled" @click="!disabled && emit(!value)">
    <label :for="`checkbox-${id}`" class="slider bg-white d-flex m-0" :class="{ 'justify-content-end' : value, 'cursor-pointer': !disabled, 'cursor-not-allowed': disabled }">
      <div class="dot d-flex justify-content-center align-items-center pointer-events-none" :class="{ 'bg-green' : value, 'bg-grey-3' : !value }">
        <i class="material-icons color-white fs-16" v-if="value">check</i>
        <i class="material-icons color-white fs-16" v-else>close</i>
      </div>
    </label>
    <label :for="`checkbox-${id}`" :class="`fs-${size} color-grey-3 font-smoothing mb-0 ml-2 ${disabled ? 'cursor-not-allowed' : ''}`" v-html="label"></label>
  </div>
</template>

<script>
export default {
  name: 'BooleanSlider',
  props: {
    value: { type: Boolean, default: false},
    label: { type: String, default: 'Label goes here' },
    size: { type: String, default: '14' },
    disabled: { type: Boolean, default: false }
  },
  data() {
    return {
      id: Math.random().toString(36).substring(7)
    }
  },
  methods: {
    emit(value) {
      this.$emit('input', value)
    }
  }
};
</script>

<style lang="scss" scoped>
label {
  margin: 0;
}
</style>
